import { Component, computed, inject, input } from '@angular/core';
import { ILpCanvasComponent, ILpCanvasElementContext } from '@gametailors/leerplus';
import { LpRidLocationTitleCanvasComponent } from '../../../../typings/schema';
import { LEERPLUS } from '../../rid-game.utils';

/** The name of the location whose map is open. Maps built from the location template are named after their location, so one template shows every location's name. */
@Component({
  selector: 'rid-location-title-canvas-component',
  templateUrl: './rid-location-title-canvas-component.html',
  host: {
    class: 'grid size-full place-items-center',
  },
})
export class RidLocationTitleCanvasComponent implements ILpCanvasComponent<LpRidLocationTitleCanvasComponent> {
  private readonly $lpApiService = inject(LEERPLUS.apiToken);

  comp = input.required<LpRidLocationTitleCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  protected readonly title = computed(() => this.$lpApiService.currentMap()?.name ?? '');
}
